import React from "react";
import {
  Box,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";

import I18nText from "../../../elements/I18nText";
import { ListActionsWrapper, DeleteAction } from "../../../elements/ListAction";
import FormattedDate from "../../../elements/FormattedDate";

const List = React.memo(({ netDevices, iotDevices, onDelete }) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box fontSize={16} fontWeight="bold">
            <I18nText>system.unassignedDevices.titleNet</I18nText>
          </Box>
        </Grid>
      </Grid>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <I18nText>devices.common.identCode</I18nText>
            </TableCell>
            <TableCell>
              <I18nText>devices.common.id</I18nText>
            </TableCell>
            <TableCell>
              <I18nText>devices.common.host</I18nText>
            </TableCell>
            <TableCell>
              <I18nText>devices.common.lastReportedAt</I18nText>
            </TableCell>
            <TableCell style={{ minWidth: 75 }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {netDevices.map(device => (
            <TableRow key={device.id}>
              <TableCell>{device.identCode}</TableCell>
              <TableCell>{device.id}</TableCell>
              <TableCell>{device.host}</TableCell>
              <TableCell>
                <FormattedDate>{device.lastReportedAt}</FormattedDate>
              </TableCell>
              <TableCell align="right">
                <ListActionsWrapper>
                  <DeleteAction onClick={() => onDelete(device)} />
                </ListActionsWrapper>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Divider style={{ marginTop: 40, marginBottom: 20 }} />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box fontSize={16} fontWeight="bold">
            <I18nText>system.unassignedDevices.titleIot</I18nText>
          </Box>
        </Grid>
      </Grid>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <I18nText>devices.common.thingName</I18nText>
            </TableCell>
            <TableCell>
              <I18nText>devices.common.id</I18nText>
            </TableCell>
            <TableCell>
              <I18nText>devices.common.lastReportedAt</I18nText>
            </TableCell>
            <TableCell style={{ minWidth: 75 }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {iotDevices.map(device => (
            <TableRow key={device.id}>
              <TableCell>{device.thingName}</TableCell>
              <TableCell>{device.id}</TableCell>
              <TableCell>
                <FormattedDate>{device.lastReportedAt}</FormattedDate>
              </TableCell>
              <TableCell align="right">
                <ListActionsWrapper>
                  <DeleteAction onClick={() => onDelete(device)} />
                </ListActionsWrapper>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
});

export default List;
